import React, { useEffect, useState, useContext } from "react";
import Dashboard from "../../layouts/Dashboard";
import { If } from "react-condition";
import TextField from "./ApplicationBuilder/TextField";
import Subheading from "./ApplicationBuilder/Subheading";
import Heading from "./ApplicationBuilder/Heading";
import Checkbox from "./ApplicationBuilder/Checkbox";
import Radio from "./ApplicationBuilder/Radio";
import TextArea from "./ApplicationBuilder/TextArea";
import Divider from "./ApplicationBuilder/Divider";
import Select from "./ApplicationBuilder/Select";
import TextTable from "./ApplicationBuilder/TextTable";
import DateField from "./ApplicationBuilder/DateField";
import EmailField from "./ApplicationBuilder/EmailField";
import NumberField from "./ApplicationBuilder/NumberField";
import Paragraph from "./ApplicationBuilder/Paragraph";
import { useRef } from "react";
import Axios from "axios";
import url from "../../services/url";
import { useHistory, useParams } from "react-router-dom";
import PasswordField from "./ApplicationBuilder/PasswordField";
import PersonalDetails from "./ApplicationBuilder/PersonalDetails";
import MultiSelect from "./ApplicationBuilder/multiSelect";
import FileInput from "./ApplicationBuilder/FileInput";
import { message } from "antd";
// import PersonalDetails from "../Candidate/ApplicationView.PersonalDetails";
import isConsultant from "../../services/isConsultant";
import { ContextApi } from "../../App";
import ProfessionalExperience from "./ApplicationBuilder/ProfessionalExperience";
import StateCity from "./ApplicationBuilder/StateCity";
import PhotoCapture from "./ApplicationBuilder/PhotoCapture";
import DateTime from "./ApplicationBuilder/DateTime";
import LoadingArea from "../../components/LoadingArea";
import useAxios from "../../hooks/useAxios";
import DeptDesg from "./ApplicationBuilder/DeptDesg";

function ApplicationBuilder() {
  const api = useAxios();
  const history = useHistory();
  const { id } = useParams();

  // States
  const [application, setApplication] = useState({
    name: "",
    elements: [],
    candidatePhoto: false,
    candidateVideo: false,
    resume: false,
    trf: "",
  });
  const [form, setForm] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formType, setFormType] = useState("");
  const contextData = useContext(ContextApi);

  // Refs
  // const requiredCandidatePhotoRef = useRef();
  // const requiredCandidatePhotoRequiredRef = useRef();
  // const requiredCandidateVideoRef = useRef();
  // const requiredCandidateVideoRequiredRef = useRef();
  // const requiredResumeRef = useRef();
  // const requiredResumeRequiredRef = useRef();
  // const trfRef = useRef();
  // const stateCityRef = useRef()
  // Parameters

  const fetchData = async () => {
    try {
      setLoading(true);
      const { data } = await api.get(`/formtemplate/${id}`);
      setApplication(data);
      data.elements.forEach((element) => {
        if (!element) return;
        setForm((previousForm) => {
          return [...previousForm, getFormComponent(element.type, element)];
        });
      });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // Effects
  useEffect(() => {
    if (!id) return;
    fetchData();
  }, [id]);

  useEffect(() => {
    // stateCityRef.current.checked = application.cityState;
    // requiredCandidatePhotoRef.current.checked = application.candidatePhoto;
    // requiredCandidatePhotoRequiredRef.current.checked =
    //   application.candidatePhotoRequired;
    // requiredCandidateVideoRef.current.checked = application.candidateVideo;
    // requiredCandidateVideoRequiredRef.current.checked =
    //   application.candidateVideoRequired;
    // requiredResumeRef.current.checked = application.resume;
    // requiredResumeRequiredRef.current.checked = application.resumeRequired;
  }, [application]);

  // Functions
  function getFormComponent(type, preset = {}) {
    let Component = null;
    switch (type) {
      case "text":
        Component = TextField;
        break;
      case "textarea":
        Component = TextArea;
        break;
      case "subheading":
        Component = Subheading;
        break;
      case "heading":
        Component = Heading;
        break;
      case "checkbox":
        Component = Checkbox;
        break;
      case "radio":
        Component = Radio;
        break;
      case "divider":
        Component = Divider;
        break;
      case "select":
        Component = Select;
        break;
      case "texttable":
        Component = TextTable;
        break;
      case "date":
        Component = DateField;
        break;
      case "email":
        Component = EmailField;
        break;
      case "number":
        Component = NumberField;
        break;
      case "password":
        Component = PasswordField;
        break;
      case "paragraph":
        Component = Paragraph;
        break;
      case "multiSelect":
        Component = MultiSelect;
        break;
      case "file":
        Component = FileInput;
        break;
      case "professionalexperience":
        Component = ProfessionalExperience;
        break;
      case "statecity":
        Component = StateCity;
        break;
      case "capturephoto":
        Component = PhotoCapture;
        break;
      case "datetime":
        Component = DateTime;
        break;
      case "departmentdesignation":
        Component = DeptDesg;
        break;
      default:
        Component = () => <div>Unknown Type of Component</div>;
        break;
    }
    return { Component, preset };
  }
  const [errorFormType, setErrorFormType] = useState("");
  const [error, setError] = useState("");
  // Events
  function onToolDragStart(event) {
    event.dataTransfer.setData("element", event.target.getAttribute("element"));
  }

  function onBuilderDrop(event) {
    event.preventDefault();
    const elementType = event.dataTransfer.getData("element");
    setForm((form) => {
      return [...form, getFormComponent(elementType)];
    });
  }

  function onBuilderDragOver(event) {
    event.preventDefault();
  }

  function onSaveApplicationTemplateClick(event) {
    event.preventDefault();

    let formName = document.querySelector("#formName").value;
    let formBuilderElements = [
      ...document.querySelectorAll(".form-builder-element"),
    ];
    formBuilderElements = formBuilderElements.map((element) =>
      JSON.parse(element.getAttribute("data"))
    );

    //duplicate label validations
    // const filterNullVal = formBuilderElements.filter((ele) => {
    //   return ele !== null;
    // });
    // let valueArr = filterNullVal.map(function (item) {
    //   if (item !== null) {
    //     return item.properties.label;
    //   }
    // });
    // let isDuplicate = valueArr.some(function (item, idx) {
    //   return valueArr.indexOf(item) != idx;
    // });

    // if (isDuplicate) {
    //   message.error("Duplicate Label Name exist!", 5);
    // } else {
    const filterNull = formBuilderElements.filter((ele) => {
      return ele !== null;
    });
    const unique = filterNull.filter(
      (a, i) => filterNull.findIndex((s) => a.id === s.id) === i
    );
    let form = {
      name: formName,
      elements: unique,
      formType: formType ? formType : application.formType,
      // cityState: stateCityRef.current.checked,
      // candidatePhoto: requiredCandidatePhotoRef.current.checked,
      // candidateVideo: requiredCandidateVideoRef.current.checked,
      // resume: requiredResumeRef.current.checked,
      // candidatePhotoRequired:
      //   requiredCandidatePhotoRequiredRef.current.checked,
      // candidateVideoRequired:
      //   requiredCandidateVideoRequiredRef.current.checked,
      // resumeRequired: requiredResumeRequiredRef.current.checked,
      // trf: trfRef.current.value,
    };
    if (formName !== "" && formName.length < 50 && formName.length > 4) {
      Axios.post(url("formtemplate/" + id), form, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
        .then((result) => {
          history.push("/form-templates");
        })
        .catch((error) => console.error(error));
    } else {
      setError("Minimum four character required ");
    }
  }

  function onElementMoveUp(event) {
    let formBuilder = event.target.parentNode;
    if (!event.target.parentNode.classList.contains("form-builder-element")) {
      formBuilder = event.target.parentNode.parentNode;
    }
    if (formBuilder.previousSibling !== null) {
      formBuilder.parentNode.insertBefore(
        formBuilder,
        formBuilder.previousSibling
      );
    }
    return;
  }

  function onElementMoveDown(event) {
    let formBuilder = event.target.parentNode;
    if (!event.target.parentNode.classList.contains("form-builder-element")) {
      formBuilder = event.target.parentNode.parentNode;
    }
    if (formBuilder.nextSibling !== null) {
      if (formBuilder.nextSibling.nextSibling !== null) {
        formBuilder.parentNode.insertBefore(
          formBuilder,
          formBuilder.nextSibling.nextSibling
        );
      } else {
        formBuilder.parentNode.append(formBuilder);
      }
    }
    return;
  }

  function onElementDelete(event, id) {
    let formBuilder = event.target.parentNode;
    if (!event.target.parentNode.classList.contains("form-builder-element")) {
      formBuilder = event.target.parentNode.parentNode;
    }
    formBuilder.parentNode.removeChild(formBuilder);
    contextData.setContextData({
      ...contextData.contextData,
      isDeletedArr: [...contextData.contextData.isDeletedArr, id],
    });
  }

  // Render
  return (
    <div>
      {!isConsultant() && (
        <Dashboard title="Application Form Builder">
          <LoadingArea isLoading={loading}>
            <div className="row">
              <div className="col-md-9">
                <h4 className="mb-4">Form Preview</h4>
                {/* Form Builder */}
                <div
                  className="builder mb-5"
                  onDrop={onBuilderDrop}
                  onDragOver={onBuilderDragOver}
                >
                  <If test={form.length === 0}>
                    <h4>Drag and Drop elements from toolbar here.</h4>
                  </If>
                  {Object.entries(form).map(([key, { Component, preset }]) => (
                    <Component
                      key={key}
                      onMoveUp={onElementMoveUp}
                      onMoveDown={onElementMoveDown}
                      onElementDelete={onElementDelete}
                      preset={preset}
                    />
                  ))}
                </div>
                {/* <div
                  style={{ display: "flex", flexDirection: "row", gap: "10px" }}
                >
                  <label for="cars">Select Form Type</label>
                  <select
                    value={formType ? formType : application.formType}
                    onClick={(e) => {
                      setFormType(e.target.value);
                    }}
                    style={{ width: "30%" }}
                    className="form-control"
                    name="cars"
                    id="cars"
                  >  
                    <option value="Skill_Form">Skill Form</option>
                    <option value="Joining_Form">Joining Form</option>
                    <option value="Document_Form">Document Form</option>
                  </select>
                </div> */}
                <div className="mb-3 d-flex">
                  {/* <div className="custom-control custom-checkbox mb-2">
                <input
                  ref={stateCityRef}
                  id="stateCity"
                  type="checkbox"
                  className="custom-control-input"
                />
                <label
                  htmlFor="stateCity"
                  className="custom-control-label"
                >
                  Add State City Controller
                </label>
              </div> */}
                </div>
                <div className="form-group">
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text input-group-text-min-width-form">
                        Select Form Type
                      </span>
                    </div>
                    <select
                      value={formType ? formType : application.formType}
                      onChange={(e) => {
                        setFormType(e.target.value);
                      }}
                      style={{ width: "30%" }}
                      className="form-control"
                      name="cars"
                      id="cars"
                    >
                      <option value="">Select Form Type</option>
                      <option value="Skill_Form">Skill Form</option>
                      <option value="Joining_Form">Joining Form</option>
                      <option value="Document_Form">Document Form</option>
                      <option value="Feedback_Form">Feedback Form</option>
                    </select>
                  </div>
                </div>

                {/* Candidate Photo */}

                {/* <div className="mb-3 d-flex">
                  <div className="custom-control custom-checkbox mb-2">
                    <input
                      ref={requiredCandidatePhotoRef}
                      id="requiredCandidatePhoto"
                      type="checkbox"
                      className="custom-control-input"
                      defaultChecked={application.candidatePhoto}
                    />
                    <label
                      htmlFor="requiredCandidatePhoto"
                      className="custom-control-label"
                    >
                      Candidate Photo
                    </label>
                  </div>
                  <div className="custom-control custom-checkbox ml-3">
                    <input
                      ref={requiredCandidatePhotoRequiredRef}
                      id="requiredCandidatePhotoRequired"
                      type="checkbox"
                      className="custom-control-input ml-5"
                    />
                    <label
                      htmlFor="requiredCandidatePhotoRequired"
                      className="custom-control-label"
                    >
                      Mandatory
                    </label>
                  </div>
                </div> */}

                {/* Candidate Video */}
                {/* <div className="mb-3 d-flex">
                  <div className="custom-control custom-checkbox mb-2">
                    <input
                      ref={requiredCandidateVideoRef}
                      id="requiredCandidateVideo"
                      type="checkbox"
                      className="custom-control-input"
                      defaultChecked={application.candidateVideo}
                    />
                    <label
                      htmlFor="requiredCandidateVideo"
                      className="custom-control-label"
                    >
                      Candidate Video
                    </label>
                  </div>
                  <div className="custom-control custom-checkbox ml-3">
                    <input
                      ref={requiredCandidateVideoRequiredRef}
                      id="requiredCandidateVideoRequired"
                      type="checkbox"
                      className="custom-control-input ml-5"
                    />
                    <label
                      htmlFor="requiredCandidateVideoRequired"
                      className="custom-control-label"
                    >
                      Mandatory
                    </label>
                  </div>
                </div> */}

                {/* Resume Upload */}
                {/* <div className="mb-3 d-flex">
                  <div className="custom-control custom-checkbox mb-2">
                    <input
                      ref={requiredResumeRef}
                      id="requiredResume"
                      type="checkbox"
                      className="custom-control-input"
                      defaultChecked={application.resume}
                    />
                    <label htmlFor="requiredResume" className="custom-control-label">
                      Resume
                    </label>
                  </div>
                  <div className="custom-control custom-checkbox ml-3">
                    <input
                      ref={requiredResumeRequiredRef}
                      id="requiredResumeRequired"
                      type="checkbox"
                      className="custom-control-input ml-5"
                    />
                    <label
                      htmlFor="requiredResumeRequired"
                      className="custom-control-label"
                    >
                      Mandatory
                    </label>
                  </div>
                </div> */}

                {/* Choose a TRF */}
                <div className="form-group">
                  {/* <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text input-group-text-min-width-form">
                    Form TRF
                  </span>
                </div>
                <select
                  ref={trfRef}
                  id="trf"
                  className="form-control"
                  defaultValue={application.trf}
                >
                  {trfs.map((trf) => (
                    <option value={trf._id} key={trf._id}>
                      {trf.title}
                    </option>
                  ))}
                </select>
              </div> */}
                </div>

                {/* Form Template Name */}
                <div className="form-group">
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text input-group-text-min-width-form">
                        Form Name
                      </span>
                    </div>
                    <input
                      id="formName"
                      type="text"
                      className="form-control"
                      placeholder="Enter Form Template name here"
                      defaultValue={application.name}
                    />
                    <p style={{ color: "red" }}>{error}</p>
                  </div>
                </div>

                <div className="form-group">
                  <button
                    className="btn btn-primary"
                    onClick={onSaveApplicationTemplateClick}
                  >
                    Update Form
                  </button>
                </div>
              </div>

              {/* Toolbar */}
              <div className="col-md-3">
                <div className="toolbox-parent">
                  <div className="toolbox">
                    <h4 className="mb-4">Toolbar</h4>
                    <div className="row">
                      <div className="col-md-12 col-lg-6">
                        <div
                          className="builder-tool"
                          onDragStart={onToolDragStart}
                          draggable={true}
                          element="text"
                        >
                          Text Field
                        </div>
                        <div
                          className="builder-tool"
                          onDragStart={onToolDragStart}
                          draggable={true}
                          element="textarea"
                        >
                          Text Area
                        </div>
                        <div
                          className="builder-tool"
                          onDragStart={onToolDragStart}
                          draggable={true}
                          element="paragraph"
                        >
                          Paragraph
                        </div>
                        <div
                          className="builder-tool"
                          onDragStart={onToolDragStart}
                          draggable={true}
                          element="checkbox"
                        >
                          Checkbox
                        </div>
                        <div
                          className="builder-tool"
                          onDragStart={onToolDragStart}
                          draggable={true}
                          element="divider"
                        >
                          Divider
                        </div>
                        <div
                          className="builder-tool"
                          onDragStart={onToolDragStart}
                          draggable={true}
                          element="texttable"
                        >
                          Text Table
                        </div>
                        <div
                          className="builder-tool"
                          onDragStart={onToolDragStart}
                          draggable={true}
                          element="email"
                        >
                          Email
                        </div>
                        <div
                          className="builder-tool"
                          onDragStart={onToolDragStart}
                          draggable={true}
                          element="file"
                        >
                          File
                        </div>
                        <div
                          className="builder-tool"
                          onDragStart={onToolDragStart}
                          draggable={true}
                          element="capturephoto"
                        >
                          Capture Photo
                        </div>
                        <div
                          className="builder-tool"
                          onDragStart={onToolDragStart}
                          draggable={true}
                          element="datetime"
                        >
                          Date Time
                        </div>
                      </div>
                      <div className="col-md-12 col-lg-6">
                        {/* <div className="builder-tool" onDragStart={onToolDragStart} draggable={true} element="heading">
                      Group Heading
                    </div> */}
                        <div
                          className="builder-tool"
                          onDragStart={onToolDragStart}
                          draggable={true}
                          element="subheading"
                        >
                          Heading
                        </div>
                        <div
                          className="builder-tool"
                          onDragStart={onToolDragStart}
                          draggable={true}
                          element="radio"
                        >
                          Radio Button
                        </div>
                        <div
                          className="builder-tool"
                          onDragStart={onToolDragStart}
                          draggable={true}
                          element="select"
                        >
                          Select
                        </div>
                        <div
                          className="builder-tool"
                          onDragStart={onToolDragStart}
                          draggable={true}
                          element="date"
                        >
                          Date
                        </div>
                        <div
                          className="builder-tool"
                          onDragStart={onToolDragStart}
                          draggable={true}
                          element="number"
                        >
                          Number
                        </div>
                        <div
                          className="builder-tool"
                          onDragStart={onToolDragStart}
                          draggable={true}
                          element="password"
                        >
                          Password
                        </div>
                        <div
                          className="builder-tool"
                          onDragStart={onToolDragStart}
                          draggable={true}
                          element="multiSelect"
                        >
                          MultiSelect
                        </div>
                        <div
                          className="builder-tool text-center"
                          onDragStart={onToolDragStart}
                          draggable={true}
                          element="professionalexperience"
                        >
                          Professional Experience
                        </div>
                        <div
                          className="builder-tool text-center"
                          onDragStart={onToolDragStart}
                          draggable={true}
                          element="statecity"
                        >
                          State City
                        </div>
                        <div
                          className="builder-tool text-center"
                          onDragStart={onToolDragStart}
                          draggable={true}
                          element="departmentdesignation"
                        >
                          Department Designation
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LoadingArea>
        </Dashboard>
      )}
    </div>
  );
}

export default ApplicationBuilder;
